<template>
  <v-container>
    <v-card>
      <v-card-title>
        Notification Service
        <v-icon right>fa-sms</v-icon>
      </v-card-title>
      <v-card-subtitle>
        <p>
          When boxes are opened, it is nice to be notified. The "box opener" has posibility to send SMS to those who have subscribed to the service for the actual area/boxes.
          Subscriptions are handled in your account settings (profile page).
        </p>
        <p>
          <v-btn to="/getprofile" small color="primary">
            Go to my account.
            <v-icon small right>fa-user-cog</v-icon>
          </v-btn>
          OR
          <v-btn to="/sendac" small color="primary">
            Email link to my account.
            <v-icon small right>fa-envelope</v-icon>
          </v-btn>
        </p>
      </v-card-subtitle>
    </v-card>
    <v-card>
      <v-card-title>
        Activation
        <v-icon right>fa-lock</v-icon>
      </v-card-title>
      <v-card-subtitle>
        <p>
          To activate the service for your notification subscriptions you need to purchase "PG Box SMS Varsling". This is done in the HLSK Web-shop, payment with Vipps.
        </p>
        <p>
          In this way, you help cover the costs and contribute to further development of PG Box.
        </p>
        <p>
          <v-btn href="https://www.hlsk.no/butikk" target="_blank" small color="primary">
            HLSK Butikk.
            <v-icon small right>fa-cart-plus</v-icon>
          </v-btn>
        </p>
        <p>
            As soon as the payment is done, an administrator will activate the service, and you will find the following message under "Notification Subscriptions" in your account settings (profile page).
        </p>
        <p>
            <strong style="color:green">Notification Service is Activated.</strong>
       </p>
        <p>In stead of this one:</p>
        <p>
            <strong style="color:red">Notification Service is Not Activated!</strong>
        </p>
      </v-card-subtitle>
    </v-card>
    <v-card>
      <v-card-title>
        Event Notification Subscriptions.
        
        <v-icon right>fa-sms</v-icon>
      </v-card-title>
      <v-card-subtitle>
        <p>
           To receive notifications, you also need to enable it for each box you want to be alerted.
        </p>
         <v-img :src="NotificationService1" height="300px"  aspect-ratio="1" contain></v-img>
        <!-- <p>
        <kbd>Notification service is currently not enabled, will be available in a later release. 
          Notification services in connection with event "NC" are handled in a special manner - and purchase is not required for this event.  
          </kbd>
        </p> -->
      </v-card-subtitle>
    </v-card>
  </v-container>
</template>

<script>
export default {
    data () {
        return {
            NotificationService1: require('@/assets/NotificationServiceHelp1.png')
        }
    }
}
</script>